<template>
  <div class="ziXunSheZhi">
    <div class="third-rea banji">
      <div class="third-btn">
        <div class="btn-left">检索条件</div>
        <div class="btn-right">
          <el-button class="btn-two" type="primary" @click="search"
            >查询</el-button
          >
          <el-button class="btn-two" type="default" @click="reset('searchForm')"
            >重置</el-button
          >
        </div>
      </div>
      <div class="third-search">
        <el-form
          :inline="true"
          :model="searchForm"
          label-width="76px"
          ref="searchForm"
        >
          <div class="search-row">
            <div class="row-item">
              <el-form-item label="栏目名称">
                <el-input
                  class="item-input"
                  :maxlength="30"
                  v-model.trim="searchForm.keyId"
                  @keyup.enter.native="search"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="资讯来源">
                <el-select
                  class="item-input"
                  v-model="searchForm.useDevice"
                  placeholder="请选择"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    value="OFFICIAL_ACCOUNT"
                    label="公众号"
                  ></el-option>
                  <el-option value="API" label="API服务"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="查看权限">
                <el-select
                  class="item-input"
                  v-model="searchForm.roleId"
                  placeholder="请选择"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option value="1" label="登录后才可查看"></el-option>
                  <el-option value="0" label="未登录可查看"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="third-one">
      <div class="third-do-btn">
        <el-button
          class="do-btn-four"
          type="default"
          icon="el-icon-plus"
          @click="edit(null)"
          >新增</el-button
        >
        <el-button
          class="do-btn-four"
          type="default"
          icon="el-icon-delete"
          @click="deleteItem(null)"
          >删除</el-button
        >
      </div>
      <div>
        <el-table
          class="third-tableThree"
          :data="tableData"
          border
          stripe
          v-loading="tableLoading"
          @select="handleSelectChange"
          @select-all="handleSelectAll"
          ref="faqRecordTableData"
          row-key="id"
        >
          <el-table-column
            type="selection"
            width="32px"
            :reserve-selection="true"
          ></el-table-column>
          <template v-for="(val, key) in tableDataShow">
            <el-table-column
              v-if="val.needKeyValue"
              min-width="100px"
              :prop="val.key"
              :label="val.column"
              :key="key"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span v-if="val.key === 'status'">
                  <span v-if="scope.row[val.key] === 1" style="color: #33cc99"
                    >启用</span
                  >
                  <span v-if="scope.row[val.key] === 0" style="color: #ff4d4f"
                    >停用</span
                  >
                </span>
                <span v-if="val.key === 'needLogin'">
                  <span v-if="scope.row[val.key] === 1">登录后才可查看</span>
                  <span v-if="scope.row[val.key] === 0">未登录可查看</span>
                </span>
                <span v-if="val.key === 'sourceType'">
                  <span v-if="scope.row[val.key] === 'OFFICIAL_ACCOUNT'"
                    >公众号</span
                  >
                  <span v-else>API服务</span>
                </span>
                <template v-if="val.key === 'viewPermission'">
                  {{ getlable(scope.row, val.key) }}
                </template>
              </template>
            </el-table-column>
            <el-table-column
              v-else
              min-width="100px"
              :prop="val.key"
              :label="val.column"
              :key="key"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
          </template>
          <el-table-column label="操作" min-width="130px">
            <template slot-scope="{ row }">
              <el-button
                v-if="row.status === 0"
                type="text"
                size="small"
                @click="enable(row, 1)"
                >启用</el-button
              >
              <el-button
                v-if="row.status === 1"
                type="text"
                size="small"
                @click="enable(row, 0)"
                >停用</el-button
              >
              <span class="tableThree-height-shu">
                <span class="shu-item"></span>
              </span>
              <el-button type="text" size="small" @click="edit(row)"
                >编辑</el-button
              >
              <span class="tableThree-height-shu">
                <span class="shu-item"></span>
              </span>
              <el-button
                type="text"
                size="small"
                @click="goAlumniDHTML(row)"
                v-if="row.sourceType == 'OFFICIAL_ACCOUNT'"
                >管理公众号</el-button
              >
              <span
                class="tableThree-height-shu"
                :style="{
                  display: row.sourceType == 'OFFICIAL_ACCOUNT' ? '' : 'none',
                }"
              >
                <span class="shu-item"></span>
              </span>
              <el-button
                type="text"
                size="small"
                @click="goApi(row)"
                v-if="row.sourceType !== 'OFFICIAL_ACCOUNT'"
                >管理API</el-button
              >
              <span
                class="tableThree-height-shu"
                :style="{
                  display: row.sourceType != 'OFFICIAL_ACCOUNT' ? '' : 'none',
                }"
              >
                <span class="shu-item"></span>
              </span>
              <el-button
                type="text"
                size="small"
                @click="handSyn(row)"
                v-if="row.sourceType !== 'OFFICIAL_ACCOUNT' && row.status === 1"
                >立即同步
              </el-button>
              <span
                class="tableThree-height-shu"
                :style="{
                  display: row.sourceType != 'OFFICIAL_ACCOUNT' ? '' : 'none',
                }"
              >
                <span class="shu-item"></span>
              </span>
              <el-button type="text" size="small" @click="deleteItem(row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="third-page">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchForm.currentPage"
            background
            :page-sizes="[10, 20, 30, 40]"
            :page-size="searchForm.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <notice-modal
      :noticeModalVisible="noticeModal"
      @noticeModalClose="closeNotice"
      @noticeModalAgree="agreeNotice"
      :noticeTitle="noticeTitle"
      :noticeSpec="noticeSpec"
      :isError="isError"
      :noticeType="noticeType"
      :btnAgree="agreeContent"
      :noticeContent="noitceContent"
    ></notice-modal>
  </div>
</template>

<script>
import {
  getPage,
  remove,
  getRoleList,
} from "@/store/appconfig/inforMationConfig"; //我的;
import { mapMutations, mapState, mapActions } from "vuex";
import { setStore, getStore } from "@/utils/store";

export default {
  name: "faqRecord_basicpage",

  data() {
    return {
      tableLoading: false,
      bmList: [], // 编码列表
      canNotClick: false, // 是否可以点击保存
      addTitle: "新增分类", // 新增弹窗名
      addModal: false, //
      isError: true, // 是否是错误提示
      noticeSpec: "分类删除后不可恢复，", // 标红提示
      noticeType: 1, // 提示类型
      agreeContent: "确定", // 提示弹窗确认按钮内容
      noticeTitle: "提示", // 提示
      noitceContent: "确定删除吗？", // 提示信息
      noticeModal: false, // 提示弹窗
      delectID: "", //删除一条数据的ID
      treeData: [
        {
          label: "所有分类",
          children: [],
          show: false,
        },
      ], // 树节点数据

      total: 0,
      tableData: [],
      hignModal: false, // 高级搜索
      searchForm: {
        keyId: "",
        useDevice: "",
        roleId: "",
        pageSize: 40,
        currentPage: 1,
      },
      checked: true,
      checkClassList: [],
      checkID: "", //表格选中的ID
      hignSearchRes: "", // 高级检索条件
      orderConfig: "", // 字段展示和顺序需要的参数
      tableDataShow: [],
      countNum: 1, // 默认为1，以提醒第一个必填
      tableRow: [
        {
          column: "栏目名称",
          key: "name",
          needKeyValue: false,
          caseKey: "account",
        },
        {
          column: "栏目顺序",
          key: "sortOrder",
          needKeyValue: false,
          caseKey: "user_name",
        },
        {
          column: "资讯来源",
          key: "sourceType",
          needKeyValue: true,
          caseKey: "role_name",
        },
        {
          column: "查看权限",
          key: "needLogin",
          needKeyValue: true,
          caseKey: "need_login",
        },
        {
          column: "查看角色",
          key: "viewPermission",
          needKeyValue: true,
          caseKey: "roleId",
        },
        {
          column: "状态",
          key: "status",
          needKeyValue: true,
          caseKey: "status",
        },
      ],
      selectData: "", // 选中分类
      apiServerDataBaseId: "", // 分类id
      deleteType: 1, // 删除类型，1分类，2单项列表删除，3批量删除, 4关闭
      deleteList: [],
      roleList: [],
      handSynId: "", //立即同步的id
    };
  },
  mounted() {
    //如果vuex中有缓存的检索条件
    if (this.$store.state.common.newSearchParams) {
      this.searchForm = this.$store.state.common.newSearchParams;
      this.questionQuizListFuc();
    } else {
      this.search();
    }

    const dispField = this.getSessonValue("faqRecord_basicpage_DisplayFied");
    const tableRow = this.getSessonValue("faqRecord_basicpage_SortData");
    if (dispField) {
      this.orderConfig = dispField;
    }
    if (tableRow) {
      this.tableDataShow = tableRow;
    } else {
      this.tableDataShow = this.tableRow;
    }
    this.questionQuizListFuc();
    this.getRoleList();
  },
  computed: {
    ...mapState({
      componentsName: (state) => state.robotsManage.robotsManageComponentName,
    }),
  },
  methods: {
    ...mapMutations({
      changeComponentName: "SET_robotsManageComponentName",
    }),
    ...mapActions(["questionQuizList", "questionQuizRemove"]),
    //启用资讯栏目
    async enable(row, checkedStatus) {
      console.log(row);
      const {
        data: { status },
      } = await this.$store.dispatch("enable", {
        id: row.id,
        status: checkedStatus,
      });
      if (status != 1000) {
        if (checkedStatus == 0) {
          this.$message.error("启用失败");
        } else {
          this.$message.error("停用失败");
        }
        return;
      }
      this.search();
    },

    //立即同步
    handSyn(row) {
      this.noticeSpec = ""; // 标红提示
      (this.noticeType = 1), // 提示类型
        (this.agreeContent = "确定"); // 提示弹窗确认按钮内容
      this.noticeTitle = "提示"; // 提示
      this.noitceContent = "请在10分钟后，前往用户端查看具体资讯"; // 提示信息
      this.handSynId = row.id;
      this.deleteType = 5;
      this.noticeModal = true;
    },

    async goHandSyn() {
      const {
        data: { status },
      } = await this.$store.dispatch("handSyn", {
        id: this.handSynId,
      });
      if (status != 1000) {
        this.$message.error("立即同步失败");
        return;
      }
      this.$message.success("立即同步成功");
      this.noticeModal = false;
      this.search();
    },
    //表格多选框选中
    handleSelectChange(selection) {
      console.log(selection);
      this.checkClassList = [];
      for (var i = 0; i <= selection.length - 1; i++) {
        this.checkClassList.push(selection[i].id);
      }
      this.checkID = this.checkClassList.join(",");
      console.log("这是我选择的选项", this.checkClassList);
    },
    //表格全选中
    handleSelectAll(selection) {
      console.log(selection);
      this.checkClassList = [];
      for (var i = 0; i <= selection.length - 1; i++) {
        this.checkClassList.push(selection[i].id);
      }
      this.checkID = this.checkClassList.join(",");
      console.log("这是我的选项", this.checkClassList);
    },
    getlable(row, key) {
      let value = row[key];

      if (row["viewPermission"] == undefined) {
        value = "";
      }
      //   debugger
      let roleArr = row["viewPermission"].split(",");
      roleArr = roleArr.filter((item) => item);
      let roleNameArr = [];
      if (roleArr.length > 0) {
        roleArr.forEach((element) => {
          const [role] = this.roleList.filter((item) => element == item.roleId);
          if (role) roleNameArr.push(role.name);
        });
      }
      value = roleNameArr.join("，");

      return value;
    },
    goAlumniDHTML(rowData) {
      this.$emit("fatherMethod", "AlumniDHTML");
      setStore({
        name: "goAlumniDHTML",
        content: rowData,
        type: "session",
      });
    },
    goApi(rowData) {
      this.$emit("fatherMethod", "AlumniPact");
      setStore({
        name: "managementAPI",
        content: rowData,
        type: "session",
      });
    },
    edit(rowData) {
      // debugger
      console.log(rowData);
      this.$emit("fatherMethod", "AlumniOpen");
      setStore({
        name: "goRowData",
        content: rowData,
        type: "session",
      });
    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.checkClassList = [];
      for (var i = 0; i <= selection.length - 1; i++) {
        this.checkClassList.push(selection[i].id);
      }
      this.checkID = this.checkClassList.join(",");
    },
    // 高级检索
    toHignSearch(res) {
      // console.log(res)
      this.hignSearchRes = res;
      this.searchForm.currentPage = 1;
      this.hignModal = false;
      this.questionQuizListFuc();
    },
    // 确认弹窗
    agreeNotice() {
      if (this.deleteType === 2) {
        this.faqRecordRemove(this.delectID);
      } else if (this.deleteType === 3) {
        console.log(this.checkID);
        this.faqRecordRemove(this.checkID);
      } else if (this.deleteType === 4) {
        this.noticeModal = false;
      } else if (this.deleteType === 5) {
        this.goHandSyn(this.handSynId);
      }
    },
    // 关闭弹窗
    closeNotice() {
      // console.log(111)
      this.delectID = "";
      this.handSynId = "";
      this.noticeModal = false;
    },
    // 删除分类
    deleteDataBase() {
      this.deleteType = 1;
      this.noticeSpec = "分类删除后不可恢复，"; // 标红提示
      (this.noticeType = 1), // 提示类型
        (this.agreeContent = "确定"); // 提示弹窗确认按钮内容
      this.noticeTitle = "提示"; // 提示
      this.noitceContent = "确定删除吗？"; // 提示信息
      this.noticeModal = true;
    },
    // 删除
    deleteItem(row) {
      console.log(row);
      this.noticeSpec = "删除后，用户端不可查看此资讯栏目,"; // 标红提示
      (this.noticeType = 1), // 提示类型
        (this.agreeContent = "确认"); // 提示弹窗确认按钮内容
      this.noticeTitle = "提示"; // 提示
      this.noitceContent = "确定删除吗？"; // 提示信息
      if (!row) {
        if (this.checkClassList.length == 0) {
          this.$message.error("请勾选数据");
        } else {
          this.deleteType = 3;
          this.noticeModal = true;
        }
      } else {
        this.delectID = row.id;
        this.deleteType = 2;
        this.noticeModal = true;
      }
    },
    // 删除数据集
    async faqRecordRemove(ids) {
      try {
        const {
          data: { msg, status },
        } = await remove({
          ids: ids,
        });
        if (status === 1000) {
          this.noticeModal = false;
          this.$message.success("删除成功");
          this.$refs.faqRecordTableData.clearSelection();
          this.checkClassList = [];
          this.delectID = "";
          this.questionQuizListFuc();
          return;
        }
        this.$message.error(msg);
      } catch (err) {
        console.log(err);
      }
    },
    // 显示高级或者不显示
    changeHign() {
      console.log(this.checked);
    },
    // 关闭弹窗
    closeModal() {
      this.hignModal = false;
    },
    // 高级检索
    hignSearch() {
      this.hignModal = true;
    },
    //条数变化
    handleSizeChange(val) {
      this.searchForm.currentPage = 1;
      this.searchForm.pageSize = val;
      this.questionQuizListFuc();
    },
    //页码变化
    handleCurrentChange(val) {
      this.searchForm.currentPage = val;
      this.questionQuizListFuc();
    },
    search() {
      this.hignSearchRes = "";
      this.searchForm.currentPage = 1;
      this.$refs.faqRecordTableData.clearSelection();
      this.questionQuizListFuc();
    },
    getTableList(value) {
      this.tableDataShow = value;
    },
    getDataOrder(value) {
      this.orderConfig = value;
      this.questionQuizListFuc();
    },
    getSessonValue(name) {
      return getStore({
        name: name,
        type: "session",
      });
    },
    //表单重置
    reset(formName) {
      this.$refs.faqRecordTableData.clearSelection();
      this.$refs[formName].resetFields();
      console.log("重置", this.searchForm);
      this.searchForm.keyId = "";
      this.searchForm.userName = "";
      this.searchForm.roleId = "";
      this.searchForm.useDevice = "";
      this.searchForm.question = "";
      this.searchForm.isMatch = "";
      this.searchForm.time = "";
      this.search();
    },
    async getRoleList() {
      const {
        data: { result, msg, status },
      } = await getRoleList();
      console.log(result, msg, status);
      if (status == 1000) {
        const aaa = result.map((item) => {
          return {
            name: item.roleName,
            roleId: item.roleId,
          };
        });
        console.log(aaa);
        this.roleList = aaa;
      }
    },
    //获取列表
    async questionQuizListFuc() {
      this.$store.commit("SET_newSearchParams", this.searchForm);
      let dataSortStr = this.orderConfig;
      if (Array.isArray(this.orderConfig)) {
        dataSortStr = this.orderConfig.join(",");
      }
      this.tableLoading = true;
      const questionQuizListFuc = await getPage({
        pageIndex: this.searchForm.currentPage,
        pageSize: this.searchForm.pageSize,
        name: this.searchForm.keyId,
        sourceType: this.searchForm.useDevice,
        needLogin: this.searchForm.roleId,
      });
      this.tableLoading = false;
      console.log(questionQuizListFuc);
      if (questionQuizListFuc.data.status === 1000) {
        if (questionQuizListFuc.data.result.records.length !== 0) {
          const arr = questionQuizListFuc.data.result.records;
          arr.forEach((item) => {
            if (item.needLogin == 0) {
              item.viewPermission = "";
            }
          });
          this.tableData = arr;
          this.total = questionQuizListFuc.data.result.total;
        } else {
          if (this.searchForm.currentPage !== 1) {
            this.searchForm.currentPage -= 1;
            this.questionQuizListFuc();
          } else {
            this.tableData = [];
            this.total = 0;
          }
        }
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
  },
};
</script>

<style lang='scss'>
.ziXunSheZhi {
  .node-delete,
  .node-edit {
    opacity: 0;
  }
  .el-tree-node__content:hover .node-delete {
    opacity: 1;
  }
  .el-tree-node__content:hover .node-edit {
    opacity: 1;
  }
  .el-tree-node .is-current > .el-tree-node__content {
    .node-delete {
      opacity: 1;
    }
    .node-edit {
      opacity: 1;
    }
  }
  .tableThree-height-shu {
    display: inline-block;
    padding: 0 4px;
    position: relative;
    .shu-item {
      position: absolute;
      width: 1px;
      height: 12px;
      background-color: #d4d4d7;
      display: inline-block;
      top: -10px;
    }
  }
  .left-tree {
    height: calc(100vh - 204px) !important;
  }
  .el-table__body-wrapper {
    height: calc(100vh - 196px) !important;
  }
  .custom-tree_tab {
    font-size: 12px;
    width: 100% !important;
    text-align: left !important;
    padding: 0 8px;
    cursor: default !important;
  }
}
.dic-modal {
  .el-dialog__body {
    height: auto;
  }
}
</style>
